import React, { useEffect, useState } from 'react';
import {Form, Row} from 'antd';
import {Col} from 'antd';
import FormItem from 'src/shared/components/form-item';
import {useIntl} from 'react-intl';
import {DatePicker} from 'formik-antd';
import {useFormikContext} from 'formik';
import moment from 'moment';

function CampaignConditions() {
  const {messages} = useIntl();
  const {setFieldValue, values} = useFormikContext<any>();
  
   useEffect(() => {
     if (
       moment(values.CustomerCreatedDateFrom) >
       moment(values.CustomerCreatedDateTo)
     ) {
       setFieldValue('CustomerCreatedDateTo', undefined);
     }
   }, [values]);
  
  useEffect(() => {
    if (
      moment(values.CustomerLastActivityDateFrom) >
      moment(values.CustomerLastActivityDateTo)
    ) {
      setFieldValue('CustomerLastActivityDateTo', undefined);
    }
  }, [values]);


   const disabledDateCustomerCreated = (current: any) => {
     if (
       current &&
       current < moment(values.CustomerCreatedDateFrom).startOf('second')
     ) {
       return true;
     }
     if (
       current &&
       current.isSame(moment(values.CustomerCreatedDateFrom).startOf('second'))
     ) {
       return true;
     }
     return false;
   };

  function disabledDateCustomerLastActivity(current: any) {
       if (
         current &&
         current < moment(values.CustomerLastActivityDateFrom).startOf('second')
       ) {
         return true;
       }
       if (
         current &&
         current.isSame(
           moment(values.CustomerLastActivityDateFrom).startOf('second'),
         )
       ) {
         return true;
       }
       return false;
  }
  return (
    <Row gutter={[0, 25]}>
      <Col span={24}>
        <FormItem
          name='CustomerCreatedDateFrom'
          label={messages['mailing.customerCreatedDateFrom'].toString()}
          fieldCommponent={
            <DatePicker
              className='fullContent'
              name='CustomerCreatedDateFrom'
              showTime
            />
          }
        />
      </Col>
      <Col span={24}>
        <FormItem
          name='CustomerCreatedDateTo'
          label={messages['mailing.customerCreatedDateTo'].toString()}
          fieldCommponent={
            <DatePicker
              disabledDate={disabledDateCustomerCreated}
              className='fullContent'
              name='CustomerCreatedDateTo'
              showTime
            />
          }
        />
      </Col>
      <Col span={24}>
        <FormItem
          name='CustomerLastActivityDateFrom'
          label={messages['mailing.customerLastActivityDateFrom'].toString()}
          fieldCommponent={
            <DatePicker
              className='fullContent'
              name='CustomerLastActivityDateFrom'
              showTime
            />
          }
        />
      </Col>
      <Col span={24}>
        <FormItem
          name='CustomerLastActivityDateTo'
          label={messages['mailing.customerLastActivityDateTo'].toString()}
          fieldCommponent={
            <DatePicker
              disabledDate={disabledDateCustomerLastActivity}
              className='fullContent'
              name='CustomerLastActivityDateTo'
              showTime
            />
          }
        />
      </Col>
    </Row>
  );
}

export default CampaignConditions;
